import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import router from '@/router/router'
import axios from 'axios'

import store from '@/store/index'

Vue.use(VueRouter)

Vue.config.productionTip = false

Vue.prototype.$axios = axios

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
